import { ImportantDocumentFlags } from 'components/documents/important-document-flags';
import { documentTypeMapping, type IImportantCargoDocumentFlags } from './types';

export const ImportantCargoDocumentFlags: React.FC<IImportantCargoDocumentFlags> = (props) => {
  const { documents } = props;

  return <ImportantDocumentFlags documents={documents} documentTypeMapping={documentTypeMapping} />;
};
